import * as React from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import Button from "@amzn/awsui-components-react/polaris/button";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Select, { SelectProps } from "@amzn/awsui-components-react/polaris/select";

export interface ApprovalResponse {
  approvalId: string;
  status: string;
  rejectionReasons?: string[];
  displayMessage?: string;
  requiredRoles?: string[];
}

interface Props {
  response: ApprovalResponse;
  onOverrideApproval: (role: string) => void;
  isOverriding: boolean;
  overrideCompleted: boolean;
}

interface State {
  selectedRole: string;
}

class ApprovalResponseSection extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const defaultRole = (props.response.requiredRoles && props.response.requiredRoles.length > 0)
      ? props.response.requiredRoles[0]
      : "PHARMACIST";
    this.state = { selectedRole: defaultRole };
  }

  render() {
    const { response, onOverrideApproval, isOverriding, overrideCompleted } = this.props;
    const { selectedRole } = this.state;
    const isHumanReview = response.status === "REQUIRES_AUTHORIZED_HUMAN_REVIEW";

    const roleOptions: SelectProps.Option[] = (response.requiredRoles && response.requiredRoles.length > 0)
      ? response.requiredRoles.map((r) => ({ label: r, value: r }))
      : [];

    const selectedRoleOption = roleOptions.find((o) => o.value === selectedRole) || null;

    return (
      <Container header={
        <Header
          variant="h3"
          actions={
            isHumanReview ? (
              <Button
                variant="primary"
                onClick={() => onOverrideApproval(selectedRole)}
                loading={isOverriding}
                disabled={overrideCompleted || !selectedRole}
              >
                {overrideCompleted ? "Override Approval Submitted" : "Submit Override Approval"}
              </Button>
            ) : undefined
          }
        >
          Approval Response
        </Header>
      }>
        <SpaceBetween size="m">
          <pre style={{
            backgroundColor: "#f5f5f5",
            border: "1px solid lightgray",
            borderRadius: "4px",
            padding: "10px",
            overflowX: "auto",
            whiteSpace: "pre-wrap",
            wordBreak: "normal",
          }}>
            {JSON.stringify(response, null, 2)}
          </pre>

          {isHumanReview && roleOptions.length > 0 && (
            <FormField label="Override Requester Role">
              <Select
                selectedOption={selectedRoleOption}
                onChange={({ detail }) => this.setState({ selectedRole: detail.selectedOption.value || "" })}
                options={roleOptions}
                disabled={overrideCompleted}
              />
            </FormField>
          )}
        </SpaceBetween>
      </Container>
    );
  }
}

export default ApprovalResponseSection;
